import React, { useState, useEffect, useRef, useContext } from "react"
import ReactPlayer from "react-player"
import { CursorContext } from '../../../context/cursorContext'

import { useFormat } from '../../../hooks/useFormat'
import useIsMobile from "../../../hooks/useIsMobile"

import "./video.scss"

const Video = props => {
  const { cursorConfig, setCursor } = useContext(CursorContext);
  // const regex = /(?<=src=").*?(?=[\?"])/
  const url = props.iframe
  const isMobile = useIsMobile;

  const [muted, mute] = useState(true)
  const [playing, setPlaying] = useState(props.landing)
  const [ready, setReady] = useState(false)
  const formatStyle = useFormat(props.format)

  const playerRef = useRef(null)

  useEffect(() => {
    if (ready && !props.landing) {
      setPlaying(props.inView)
      window.setTimeout(() => {
        playerRef.current && playerRef.current.seekTo(0)
      }, 100)
    }
  }, [props.inView, ready])

  return (
    <>
      <div
        className={`video-wrapper hero ${props.format.shadow ? "shadow" : ""} ${ready ? 'ready' : 'hidden'}`}
        style={formatStyle}
      >
        <ReactPlayer
          url={url}
          playing={playing || isMobile}
          loop={true}
          volume={1}
          muted={muted}
          width={"100%"}
          height={"100%"}
          ref={playerRef}
          onReady={() => setReady(true)}
          playsinline={true}
        />
      </div>
      {props.format.mute && (
        <div
          onMouseEnter={
            () => setCursor({ 
              ...cursorConfig, 
              rotation: -30,
              scale: "1",
              shape: "default", 
              color: "var(--black)",
              translation: "-6px, -6px",
            })
          }
          role="button"
          onClick={() => mute(muted ? false : true)}
          className={
            muted
              ? "video-button mute muted " + props.format?.boundaries
              : "video-button mute " + props.format?.boundaries
          }
        />
      )}
    </>
  )
}

export default Video
